import './ProviderDataStyle.css';
import { Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';

export default function ERA5WAVEMODELLING() {
  return (
    <>
      <div className="dialogWarning">
        MIKE Data Link carries out comprehensive quality control checks on all third-party datasets.
        However, errors and inconsistencies inherited from these datasets (for example, missing
        values) may appear as errors in extracted data. If you encounter incorrect values such as
        NaN or erroneous zero values in extracted boundary conditions, initial conditions, or
        forcings output files, please contact{' '}
        <a href="mailto:mike@dhigroup.com">mike@dhigroup.com.</a>
      </div>
      <div className="dialogSummary">
        {"This data set is based on the ERA5 data set. It consists of an additional variable for wind speed at 10m, with wind speeds > 12 m/s corrected by DHI for wave model forcing."}
      </div>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              General
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Title</TableCell>
            <TableCell>Global-AT_ERA5 for wave modelling</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Geographical Coverage</TableCell>
            <TableCell>Global</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Category</TableCell>
            <TableCell>Meteorological Parameters</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Source Name</TableCell>
            <TableCell>ECMWF Reanalysis v5 (ERA5), Selected Hourly Time-series products, modified by DHI</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Publisher</TableCell>
            <TableCell>European Center for Medium-Range Weather Forecasts (ECMWF), DHI</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Product type</TableCell>
            <TableCell>Grid</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Cost (ex. VAT)</TableCell>
            <TableCell>Free</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Typical Applications</TableCell>
            <TableCell>Wave modelling</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>References</TableCell>
            <TableCell>
              <a
                href="https://confluence.ecmwf.int/display/CKB/ERA5%3A+data+documentation#heading-TheIFSanddataassimilation"
                target="_blank"
                rel="noopener noreferrer">
                ECWMF ERA5 documentation
              </a>
              <br />
              <a
                href="https://cds.climate.copernicus.eu/datasets/reanalysis-era5-single-levels?tab=overview"
                target="_blank"
                rel="noopener noreferrer">
                ERA5 dataset description
              </a>
              <br />             
              <a
                href="https://www.metocean-on-demand.com/fileshare/getfile.ashx?type=document&file_name=11824836_EUDP_Global_Atlas_of_Siting_ERA5_Wind_Validation_Version1_2023-06-07.pdf"
                target="_blank"
                rel="noopener noreferrer">
                DHI modifications              
              </a>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              Coverage
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Geographical Range</TableCell>
            <TableCell>
              Global: <br />
              Longitude: -180°W to 180°E <br /> Latitude: -90°S to 90°N
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Geographical Resolution</TableCell>
            <TableCell>0.25 degree</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Vertical Reference</TableCell>
            <TableCell>Sea surface</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Temporal Reference</TableCell>
            <TableCell>UTC</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Temporal Range</TableCell>
            <TableCell>
              Data Link coverage: 1/1-1979 -&gt; Present
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Temporal Resolution</TableCell>
            <TableCell>1 hour</TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              Variables
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Name (Unit)</TableCell>
            <TableCell>Wind velocity components (Speed & direction) at 10m [m/s]</TableCell>            
          </TableRow>          
        </TableBody>
      </Table>
    </>
  );
}
